export type mailServiceTypes = 'sendgrid' | 'emailer'
export type emailTypes = 'confirmEmail' | 'passwordReset' | 'invite' | 'marketing' | 'support' | 'inviteStatus' | 'registrationReminder' | 'finishRegistration' | 'mentioned' | 'followed' | 'liked' | 'posted' | 'alert' | 'auctionPost' | 'auctionOutbid' | 'auctionFailure' | 'auctionSuccess' | 'auctionUnfulfilled' | 'auctionCanceled' | 'newsletter' | 'offerReceived' | 'offerAccepted'

export function getDescriptionFromEmailType(emailType: emailTypes): string {
  if (emailType === 'confirmEmail') return 'Email confirmations'
  if (emailType === 'invite') return 'Invitations to join'
  if (emailType === 'marketing') return 'Marketing messages'
  if (emailType === 'passwordReset') return 'Password reset requests'
  if (emailType === 'support') return 'Customer support messages'
  if (emailType === 'inviteStatus') return 'Invitation status messages'
  if (emailType === 'registrationReminder') return 'Registration reminder messages'
  if (emailType === 'finishRegistration') return 'Finish registration messages'
  if (emailType === 'mentioned') return 'Mentioned messages'
  if (emailType === 'followed') return 'Followed messages'
  if (emailType === 'liked') return 'Liked messages'
  if (emailType === 'posted') return 'Messages about posts'
  if (emailType === 'alert') return 'Alerts'
  if (emailType === 'auctionPost') return 'Auction post confirmations'
  if (emailType === 'auctionOutbid') return 'Auction outbid notices'
  if (emailType === 'auctionFailure') return 'Auction failed to sell notices'
  if (emailType === 'auctionSuccess') return 'Auction success notices'
  if (emailType === 'auctionUnfulfilled') return 'Auction unfulfilled notice'
  if (emailType === 'auctionCanceled') return 'Auction canceled notice'
  if (emailType === 'newsletter') return 'Newsletter emails'
  if (emailType === 'offerReceived') return 'Offer received emails'
  if (emailType === 'offerAccepted') return 'Offer accepted emails'
  return emailType
}  

(async () => {
})();
